import { render } from "./CostProportions.vue?vue&type=template&id=1fe2fcbe&scoped=true"
import script from "./CostProportions.vue?vue&type=script&lang=js"
export * from "./CostProportions.vue?vue&type=script&lang=js"

import "./CostProportions.vue?vue&type=style&index=0&id=1fe2fcbe&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2fcbe"]])

export default __exports__